// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"04e216f8f37c4ee3e249","245":"006a72904f6e6d70bfdd","452":"f77cf46bb6acc1853dc6","453":"9c575716c61557b53f0a"}[chunkId] + ".js";
};